var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mobile-template',[_c('div',{staticClass:"p-6 bg-white"},[_c('h1',{staticClass:"text-2xl font-bold mb-4 pb-4 border-b"},[_vm._v("Nouvelle intervention")]),_c('chantier-init',{on:{"slots-created":_vm.onChantierCreated}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }